import React from "react";
import { Route, Routes } from "react-router";
import Chats from "../containers/admin/ChatLayout";
import Settings from "../containers/admin/Settings";
import Task from "../containers/admin/Task";
import EmployeeTask from "../containers/admin/Task/EmployeeTask";
import IncomingCallModal from "../containers/admin/ChatLayout/Message/ChatHeader/IncomingCallModal";
import ActiveCallModal from "../containers/admin/ChatLayout/Message/ChatHeader/ActiveCallModal";

const employeeRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/chats" element={<Chats />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/task" element={<EmployeeTask />} />
      </Routes>
      <IncomingCallModal />
      <ActiveCallModal />
    </div>
  );
};

export default employeeRoutes;
